import React from "react";
import LineItemsDoc from "../components/LineItemsDoc";
import { DOC_CONFIGS } from "../lib/docConfigs";

export default function Purchase() {
  return (
    <div>
      <div className="mb-5"><h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-head">Purchase Bills</h1>
        <p className="text-sm text-slate-500 mt-0.5">Multi-item purchase bills · supplier details snapshot · auto stock-in on save</p></div>
      <LineItemsDoc config={DOC_CONFIGS["purchase-bills"]} />
    </div>
  );
}
